import React, { useState, useRef, useEffect } from 'react';
import Select from 'react-select'
import DropdownReportOption from '../../../container/dropdown/dropdown-report-create/DropdownReportOption';
import DateRangePickerWithCalendar from '../../calendar/DateRangePickerWithCalendar';
import SubQueryOption from './SubQueryOption';

import './ReportCreateOptionBar.css';
import ReportTypeOption from './ReportTypeOption';
import { REPORT_TYPE_SET } from '../../../../config/ReportOptionSet';
import ReportOptions from './ReportOptions';
import ReportChannelOption from './ReportChannelOption';
import DropdownReportLabel from '../../../container/dropdown/dropdown-report-create/DropdownReportLabel';
import TooltipWithTimer from '../../tooltip/TooltipWithTimer';
import Dropdown from 'react-bootstrap/esm/Dropdown';
import CheckboxImg from '../../checkbox/CheckboxImg';

const DateIndicator = (props) => {
  const activeStyle={
    background: "#BEB4FF",
    color: "#ffffff"
  }
  if (props.onDateBtn == "w1"){
    return (
      <>
        <a className="button option" style={activeStyle} name="1week" onClick={(e)=>props.handleDateBtn(e)}>1W</a>
        <a className="button option" name="2week" onClick={(e)=>props.handleDateBtn(e)}>2W</a>
        <a className="button option" name="1month" onClick={(e)=>props.handleDateBtn(e)}>1M</a>
        <a className="button option" name="3month" onClick={(e)=>props.handleDateBtn(e)}>3M</a>
      </>
    )
  }
  else if (props.onDateBtn == "w2"){
    return (
      <>
        <a className="button option" name="1week" onClick={(e)=>props.handleDateBtn(e)}>1W</a>
        <a className="button option" style={activeStyle} name="2week" onClick={(e)=>props.handleDateBtn(e)}>2W</a>
        <a className="button option" name="1month" onClick={(e)=>props.handleDateBtn(e)}>1M</a>
        <a className="button option" name="3month" onClick={(e)=>props.handleDateBtn(e)}>3M</a>
      </>
    )
  }
  else if (props.onDateBtn == "m1"){
    return (
      <>
        <a className="button option" name="1week" onClick={(e)=>props.handleDateBtn(e)}>1W</a>
        <a className="button option" name="2week" onClick={(e)=>props.handleDateBtn(e)}>2W</a>
        <a className="button option" style={activeStyle} name="1month" onClick={(e)=>props.handleDateBtn(e)}>1M</a>
        <a className="button option" name="3month" onClick={(e)=>props.handleDateBtn(e)}>3M</a>
      </>
    )
  }
  else if (props.onDateBtn == "m3"){
    return (
      <>
        <a className="button option" name="1week" onClick={(e)=>props.handleDateBtn(e)}>1W</a>
        <a className="button option" name="2week" onClick={(e)=>props.handleDateBtn(e)}>2W</a>
        <a className="button option" name="1month" onClick={(e)=>props.handleDateBtn(e)}>1M</a>
        <a className="button option" style={activeStyle} name="3month" onClick={(e)=>props.handleDateBtn(e)}>3M</a>
      </>
    )
  }
  else {
    return (
      <>
        <a className="button option" name="1week" onClick={(e)=>props.handleDateBtn(e)}>1W</a>
        <a className="button option" name="2week" onClick={(e)=>props.handleDateBtn(e)}>2W</a>
        <a className="button option" name="1month" onClick={(e)=>props.handleDateBtn(e)}>1M</a>
        <a className="button option" name="3month" onClick={(e)=>props.handleDateBtn(e)}>3M</a>
      </>
    )
  }
}

// const DateIndicator = (props) => {
//   const activeStyle={
//     background: "#BEB4FF",
//     color: "#ffffff"
//   }
//   if (props.onDateBtn == "w1"){
//     return (
//       <>
//         <a className="button indicator" style={activeStyle} name="1week" onClick={(e)=>props.handleDateBtn(e)}>1W</a>
//         <a className="button indicator" name="2week" onClick={(e)=>props.handleDateBtn(e)}>2W</a>
//         <a className="button indicator" name="1month" onClick={(e)=>props.handleDateBtn(e)}>1M</a>
//         <a className="button indicator" name="3month" onClick={(e)=>props.handleDateBtn(e)}>3M</a>
//       </>
//     )
//   }
//   else if (props.onDateBtn == "w2"){
//     return (
//       <>
//         <a className="button indicator" name="1week" onClick={(e)=>props.handleDateBtn(e)}>1W</a>
//         <a className="button indicator" style={activeStyle} name="2week" onClick={(e)=>props.handleDateBtn(e)}>2W</a>
//         <a className="button indicator" name="1month" onClick={(e)=>props.handleDateBtn(e)}>1M</a>
//         <a className="button indicator" name="3month" onClick={(e)=>props.handleDateBtn(e)}>3M</a>
//       </>
//     )
//   }
//   else if (props.onDateBtn == "m1"){
//     return (
//       <>
//         <a className="button indicator" name="1week" onClick={(e)=>props.handleDateBtn(e)}>1W</a>
//         <a className="button indicator" name="2week" onClick={(e)=>props.handleDateBtn(e)}>2W</a>
//         <a className="button indicator" style={activeStyle} name="1month" onClick={(e)=>props.handleDateBtn(e)}>1M</a>
//         <a className="button indicator" name="3month" onClick={(e)=>props.handleDateBtn(e)}>3M</a>
//       </>
//     )
//   }
//   else if (props.onDateBtn == "m3"){
//     return (
//       <>
//         <a className="button indicator" name="1week" onClick={(e)=>props.handleDateBtn(e)}>1W</a>
//         <a className="button indicator" name="2week" onClick={(e)=>props.handleDateBtn(e)}>2W</a>
//         <a className="button indicator" name="1month" onClick={(e)=>props.handleDateBtn(e)}>1M</a>
//         <a className="button indicator" style={activeStyle} name="3month" onClick={(e)=>props.handleDateBtn(e)}>3M</a>
//       </>
//     )
//   }
//   else {
//     return (
//       <>
//         <a className="button indicator" name="1week" onClick={(e)=>props.handleDateBtn(e)}>1W</a>
//         <a className="button indicator" name="2week" onClick={(e)=>props.handleDateBtn(e)}>2W</a>
//         <a className="button indicator" name="1month" onClick={(e)=>props.handleDateBtn(e)}>1M</a>
//         <a className="button indicator" name="3month" onClick={(e)=>props.handleDateBtn(e)}>3M</a>
//       </>
//     )
//   }
// }

const ReportCreateOptionBar = (props) => {
  const [tooltipShow, setTooltipShow] = useState(false);
  const tooltipTarget = useRef(null);

  useEffect(() => {
    const timerId = setInterval(() => {
      if(tooltipShow) setTooltipShow(false);
    }, 3000);
    return ()=>clearInterval(timerId);
  }, [tooltipShow])

  return (
    <div className="reportTopBg">
      <div className="settingBox">
        <div className="analysis_indicator">
          <div className="indicator-box">
            날짜 <DateIndicator handleDateBtn={props.handleDateBtn} onDateBtn={props.onDateBtn} />
            &nbsp;&nbsp;<DropdownReportOption img="calendar" >
              <DateRangePickerWithCalendar authed={true} minDate={props.minDate} value={props.dateRange} onChange={props.handleDate} />
            </DropdownReportOption>
          </div>
          <div className="indicator-box">
            <span style={{paddingLeft:"30px"}}>검색어&nbsp;&nbsp;</span>
            {props.edit ?
              props.defaultQuery.mainQuery && 
              <Select placeholder="검색어 찾기" isClearable={true} isSearchable={true}
                defaultValue={props.defaultQuery.mainQuery}
                options={props.querySelectOption}
                styles={{
                  container: base => ({
                    ...base,
                    width: "180px",
                    marginTop: "-6px"
                  }),
                  option: base => ({
                    ...base,
                    textAlign: "left"
                  })
                }}
                onChange={(e)=>{
                  props.selectMainQuery(e);
                }}
              />
            :<Select placeholder="검색어 찾기" isClearable={true} isSearchable={true}
            options={props.querySelectOption}
            styles={{
              container: base => ({
                ...base,
                width: "180px",
                marginTop: "-6px"
              }),
              option: base => ({
                ...base,
                textAlign: "left"
              })
            }}
            onChange={(e)=>{
              props.selectMainQuery(e);
            }}
          />}&nbsp;
            <DropdownReportOption>
              {props.edit ? <SubQueryOption edit={true} defaultQuery={props.defaultQuery} subQueryType={props.subQueryType} mainQuery={props.mainQuery} handleSubQueryType={props.handleSubQueryType} selectSubQuery={props.selectSubQuery} multiQuerySelectOption={props.multiQuerySelectOption} />
              : <SubQueryOption subQueryOptionList={props.subQueryOptionList} subQueryType={props.subQueryType} mainQuery={props.mainQuery} handleSubQueryType={props.handleSubQueryType} selectSubQuery={props.selectSubQuery} multiQuerySelectOption={props.multiQuerySelectOption} />}
            </DropdownReportOption>
          </div>
          <div className="indicator-box">
            <span style={{paddingLeft:"30px"}}>분석 지표</span>
            <span className="indTxt">{REPORT_TYPE_SET[props.reportType]}</span>
            <DropdownReportOption>
              <ReportTypeOption handleReportType={props.handleReportType} currentRole={props.currentRole}/>
            </DropdownReportOption>
          </div>
          <div className="indicator-box">
            <span style={{paddingLeft:"30px"}}>옵션&nbsp;&nbsp;</span>
            <ReportOptions reportType={props.reportType} handleReTweet={props.handleReTweet} handleOptions={props.handleOptions} options={props.options} reTweet={props.reTweet} currentRole={props.currentRole}/>
          </div>
        </div>
        <hr style={{height:"1px", border: "0 none", color: "#ccc", backgroundColor: "#e3e3e3", margin:"7.5px"}}/>
        <div className="analysis_indicator">
          <div className="indicator-box">
            <span>[분석 채널]</span>
            {props.channels.map((channel)=>{
              return (
                <div className="indicator-box-channel">
                  <span style={{paddingRight:"10px"}}>
                    <CheckboxImg labelName={channel.name} className="channel-list-checkbox" checked={channel.checked} id={`channel-checkbox-${channel.id}`} handleCheckBox={props.handleChannels} />
                    {/* {channel.name} */}
                  </span>
                  {channel.subCh.length != 0 ?
                    <DropdownReportOption>
                      <ReportChannelOption checkArray={channel.subCh} handleCheckBox={props.handleChannels} />
                      <Dropdown.ItemText style={{marginBottom: "5px"}} className="optionSettingBtn">
                        <Dropdown.Item style={{width: "auto", marginTop: "10px"}} className="button purple_line">확인</Dropdown.Item>
                      </Dropdown.ItemText>
                    </DropdownReportOption>
                  : undefined}
                </div>
              )
            })}
          </div>
        </div>
      </div>
      <div className="settingBtn">
        <a className="button purple" onClick={()=>props.handleRunBtn()}>실행</a>&nbsp;
        {props.edit ? 
          <DropdownReportLabel reportLabel={props.reportLabel} toggle="수정" handleSaveBtn={(report, label, labelID)=>props.handleSaveBtn(report, label, labelID)} tooltipRef={tooltipTarget} handleTooltip={(bool)=>setTooltipShow(bool)} userLabelData={props.userLabelData}/>
          :<DropdownReportLabel reportLabel={props.reportLabel} toggle="저장" handleSaveBtn={(report, label, labelID)=>props.handleSaveBtn(report, label, labelID)} tooltipRef={tooltipTarget} handleTooltip={(bool)=>setTooltipShow(bool)} userLabelData={props.userLabelData}/>}
        <TooltipWithTimer target={tooltipTarget} show={tooltipShow}
          tooltipDirection="top" tooltipText="리포트가 저장되었습니다" />
      </div>
    </div>
  )

  // return (
  //   <div className="reportTopBg">
  //     <div className="settingBox">
  //       <div className="indicatorSetting">
  //         <div className="indicator-box">
  //           <span className="option-tit">날짜:&nbsp;&nbsp;</span>
  //           <DateIndicator handleDateBtn={props.handleDateBtn} onDateBtn={props.onDateBtn} />
  //           <DropdownReportOption img="calendar" >
  //             <DateRangePickerWithCalendar authed={true} minDate={props.minDate} value={props.dateRange} onChange={props.handleDate} />
  //           </DropdownReportOption>
  //         </div>
  //         <div className="indicator-box">
  //           <span className="option-tit">검색어:&nbsp;&nbsp;</span>
  //           {props.edit ?
  //             props.defaultQuery.mainQuery && 
  //             <Select placeholder="검색어 찾기" isClearable={true} isSearchable={true}
  //               defaultValue={props.defaultQuery.mainQuery}
  //               options={props.querySelectOption}
  //               styles={{
  //                 container: base => ({
  //                   ...base,
  //                   width: "193px"
  //                 }),
  //                 option: base => ({
  //                   ...base,
  //                   textAlign: "left"
  //                 })
  //               }}
  //               onChange={(e)=>{
  //                 props.selectMainQuery(e);
  //               }}
  //             />
  //           :<Select placeholder="검색어 찾기" isClearable={true} isSearchable={true}
  //           options={props.querySelectOption}
  //           styles={{
  //             container: base => ({
  //               ...base,
  //               width: "193px"
  //             }),
  //             option: base => ({
  //               ...base,
  //               textAlign: "left"
  //             })
  //           }}
  //           onChange={(e)=>{
  //             props.selectMainQuery(e);
  //           }}
  //         />}&nbsp;
  //           <DropdownReportOption>
  //             {props.edit ? <SubQueryOption edit={true} defaultQuery={props.defaultQuery} subQueryType={props.subQueryType} mainQuery={props.mainQuery} handleSubQueryType={props.handleSubQueryType} selectSubQuery={props.selectSubQuery} multiQuerySelectOption={props.multiQuerySelectOption} />
  //             : <SubQueryOption subQueryType={props.subQueryType} mainQuery={props.mainQuery} handleSubQueryType={props.handleSubQueryType} selectSubQuery={props.selectSubQuery} multiQuerySelectOption={props.multiQuerySelectOption} />}
  //           </DropdownReportOption>
  //         </div>
  //         <div className="indicator-box">
  //           <span className="option-tit">분석 지표:&nbsp;</span>
  //           <span className="dropdown-tit">{REPORT_TYPE_SET[props.reportType]}</span>
  //           <DropdownReportOption>
  //             <ReportTypeOption handleReportType={props.handleReportType}/>
  //           </DropdownReportOption>
  //         </div>
  //         <div className="indicator-box">
  //           <span className="option-tit">옵션:&nbsp;&nbsp;</span>
  //           <ReportOptions reportType={props.reportType} handleReTweet={props.handleReTweet} handleOptions={props.handleOptions} options={props.options} reTweet={props.reTweet} />
  //         </div>
  //         <div className="indicator-box">
  //           <span className="option-tit">분석 채널:&nbsp;</span>
  //           {props.channels.map((channel)=>{
  //             return (
  //               <div className="indicator-box-channel">
  //                 <span className="dropdown-tit">
  //                   <Checkbox className="list-checkbox" checked={channel.checked} id={`channel-checkbox-${channel.id}`} handleCheckBox={props.handleChannels} />
  //                   {channel.name}
  //                 </span>
  //                 {channel.subCh.length != 0 ?
  //                   <DropdownReportOption>
  //                     <ReportChannelOption checkArray={channel.subCh} handleCheckBox={props.handleChannels} />
  //                     <Dropdown.ItemText style={{marginBottom: "5px"}} className="optionSettingBtn">
  //                       <Dropdown.Item style={{width: "auto", marginTop: "10px"}} className="button grayS filter">확인</Dropdown.Item>
  //                     </Dropdown.ItemText>
  //                   </DropdownReportOption>
  //                 : undefined}
  //               </div>
  //             )
  //           })}
  //         </div>
  //       </div>
  //     </div>
  //     <div className="settingBtn">
  //       <a className="button purple" onClick={()=>props.handleRunBtn()}>실행</a>
  //       {props.edit ? 
  //         <DropdownReportLabel reportLabel={props.reportLabel} toggle="수정" handleSaveBtn={(report, label, labelID)=>props.handleSaveBtn(report, label, labelID)} tooltipRef={tooltipTarget} handleTooltip={(bool)=>setTooltipShow(bool)} userLabelData={props.userLabelData}/>
  //         :<DropdownReportLabel reportLabel={props.reportLabel} toggle="저장" handleSaveBtn={(report, label, labelID)=>props.handleSaveBtn(report, label, labelID)} tooltipRef={tooltipTarget} handleTooltip={(bool)=>setTooltipShow(bool)} userLabelData={props.userLabelData}/>}
  //       <TooltipWithTimer target={tooltipTarget} show={tooltipShow}
  //         tooltipDirection="top" tooltipText="리포트가 저장되었습니다" />
  //     </div>
  //   </div>
  // )
}

export default ReportCreateOptionBar;